import React, { useEffect, useState } from 'react';
import { Mail, Phone, ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { getAllCustomers } from '../../utils/adminApi';

const AdminCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedCustomer, setExpandedCustomer] = useState(null);

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const data = await getAllCustomers();
      setCustomers(data);
    } catch (error) {
      console.error('Error fetching customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleExpand = (email) => {
    setExpandedCustomer(expandedCustomer === email ? null : email);
  };

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-zinc-100">Customers</h1>
        <p className="text-zinc-400 mt-1">View all your customers</p>
      </div>

      <Card className="bg-zinc-900 border-zinc-800">
        <CardHeader>
          <CardTitle className="text-zinc-100">All Customers ({customers.length})</CardTitle>
        </CardHeader>
        <CardContent>
          {loading ? (
            <p className="text-zinc-500 text-center py-8">Loading...</p>
          ) : customers.length === 0 ? (
            <p className="text-zinc-500 text-center py-8">No customers yet</p>
          ) : (
            <div className="space-y-2">
              {customers.map((customer) => (
                <div key={customer.email} className="border border-zinc-800 rounded-lg overflow-hidden">
                  <div className="flex items-center justify-between p-4 bg-zinc-950 hover:bg-zinc-900 cursor-pointer transition-colors" onClick={() => toggleExpand(customer.email)}>
                    <div className="flex-1">
                      <div className="font-semibold text-zinc-100">{customer.customerName}</div>
                      <div className="text-sm text-zinc-400">{customer.phone}</div>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="text-right mr-4">
                        <div className="text-sm text-zinc-500">Total Revenue</div>
                        <div className="font-semibold text-zinc-100">€{customer.totalSpent?.toFixed(2)}</div>
                      </div>
                      <Button variant="ghost" size="sm" className="text-zinc-400">
                        {expandedCustomer === customer.email ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                      </Button>
                    </div>
                  </div>
                  
                  {expandedCustomer === customer.email && (
                    <div className="p-4 bg-zinc-900 border-t border-zinc-800">
                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <div className="text-sm text-zinc-500 mb-1">Email</div>
                          <div className="flex items-center text-zinc-300">
                            <Mail className="w-4 h-4 mr-2" />
                            {customer.email}
                          </div>
                        </div>
                        <div>
                          <div className="text-sm text-zinc-500 mb-1">Phone</div>
                          <div className="flex items-center text-zinc-300">
                            <Phone className="w-4 h-4 mr-2" />
                            {customer.phone}
                          </div>
                        </div>
                        <div>
                          <div className="text-sm text-zinc-500 mb-1">Total Bookings</div>
                          <div className="font-semibold text-zinc-100">{customer.totalBookings}</div>
                        </div>
                        <div>
                          <div className="text-sm text-zinc-500 mb-1">Last Booking</div>
                          <div className="text-zinc-300">
                            {customer.lastBooking ? new Date(customer.lastBooking).toLocaleDateString() : 'N/A'}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminCustomers;
